import { render, staticRenderFns } from "./DocumentPolicyForm.vue?vue&type=template&id=6e0dd06b"
import script from "./DocumentPolicyForm.vue?vue&type=script&lang=js"
export * from "./DocumentPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports